import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDayNightTheme } from "./hooks/useDayNightTheme";
import PublicLayout from "./layouts/PublicLayout";
import AdminLayout from "./layouts/AdminLayout";
import AboutPage from "./pages/AboutPage";
import NotFoundPage from "./pages/NotFoundPage";
import HomePage from "./pages/HomePage";
import Portfolio from "./components/Portfolio";
import Collections from "./components/Collections";
import CollectionDetail from "./components/CollectionDetail";
import LocationsHubPage from "./pages/LocationsHubPage";
import LocationDetailPage from "./pages/LocationDetailPage";
import AdminPage from "./components/AdminPage";
import ErrorBoundary from "./components/ErrorBoundary";
import "./App.css";

function AppRoutes() {
  useDayNightTheme();
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/collections" element={<Collections />} />
        <Route path="/collections/:key" element={<CollectionDetail />} />
        <Route path="/locations" element={<LocationsHubPage />} />
        <Route path="/locations/:countryCode" element={<LocationDetailPage />} />
        {/* Catch-all: unmatched public URLs render a 404 instead of a blank page. Keep last. */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route element={<AdminLayout />}>
        <Route path="/admin" element={<AdminPage />} />
      </Route>
    </Routes>
  );
}

const App = () => {
  return (
    <ErrorBoundary>
      <Router>
        <AppRoutes />
      </Router>
    </ErrorBoundary>
  );
};

export default App;
